goog.provide('el8.appshared.dialog.createLabResultVendor');

goog.require('el8.template.appshared.dialog.createLabResultVendor');
goog.require('el8.uiwidget.FormDialog');
goog.require('el8.uiwidget.Form');
goog.require('el8.util.consts');
goog.require('el8.appservice.notifier');


el8.appshared.dialog.createLabResultVendor = (function(){

    var saveCallbackFn = null;
    var hideCallbackFn = null;

    var that = new el8.uiwidget.FormDialog({
        title: 'Create New Lab Vendor',
        modal: true,
        position: 'center',
        autoHeight: true,
        width: 350,
        contentFn: el8.template.appshared.dialog.createLabResultVendor.content
    });

    var form = new el8.uiwidget.Form({
        fields: [
            {
                name: 'vendorName',
                selector: ':input[name="vendorName"]',
                infoText: 'new vendor name...',
                height: el8.util.consts.DEFAULT_FIELD_HEIGHT,
                maxLength: 100
            }
        ]
    });

    form.addButton('save', 'Create Vendor', function(_form) {
        el8.appservice.notifier.notify('Creating new vendor...');
        $.el8_ajax({
            url: el8.service.urls.get('labTestVendors'),
            type: 'POST',
            data: {'data': JSON.stringify(_form.getMapped(true, true))},
            success: function(data) {
                el8.appservice.notifier.notify('New vendor created.');
                that.hide();
                if (saveCallbackFn) { saveCallbackFn(data); }
            },
            error_override: function(data) {
                //409 = "conflict" and we use it here to represent a vendor that already exists
                if (data.status === 409) {
                    el8.uiwidget.alert("It looks like you've already created this vendor. Please contact support if that is not true.");
                } else {
                    el8.uiwidget.alert('Oops! There was an error creating this vendor. Please refresh your page and contact support if the error does not go away.');
                }
            }
        });
    }, true);
    form.addDiscardButton(function(_form) {
        if (hideCallbackFn) { hideCallbackFn(); }
        that.hide();
    }, false);
    that.setForm(form);

    var super_show = that.show;
    that.show = function(opts) {
        opts = opts || {};
        
        super_show.call(that);
        saveCallbackFn = opts.saveCb || null;
        hideCallbackFn = opts.hideCb || null;
    };

    return that;
})();
